module.exports = __webpack_public_path__ + "assets/icons/parameters-logo.6535acf87739511058db3217743da1d5.svg";